import axios from '../utils/axios';

export default function updateDiversityPlan(adminId, data) {
    return axios.post('/admin/' + adminId + '/update-diversity-plan', data);
}